import { Directive, Injector, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';

import { ClientPermissionDirectivesBase } from './base-client';

import { CLIENT_TYPES } from 'src/app/authorization/authentication.service';

@Directive({
    selector: '[ASSET_TRACKING]'
})
export class DirectiveAssetTrackingDirectiveAC extends ClientPermissionDirectivesBase {

    constructor(
        injector: Injector,
        element: ElementRef,
        templateRef: TemplateRef<any>,
        viewContainer: ViewContainerRef
    ) {
        super(injector, element, templateRef, viewContainer, CLIENT_TYPES.ASSET_TRACKING);
    }
}